// @ts-nocheck
import { Typography } from '@sureco/design-system'
import {
  Button,
  Spin,
  Tabs,
  TabsProps,
  Tag,
} from '@surecompanies/core_components'
import { useRouterContext } from 'components/RouterContext'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { useSearchParams } from 'hooks/useSearchParams'
import Page from 'layouts/Page'
import React from 'react'
import { CUSTOMER_MANAGEMENT } from '../../paths'
import { IconStatusMapper } from '../ListCustomer/hooks/useListCustomer'
import useViewCustomer from './hooks/useViewCustomer'
import AdminTab from './tabs/Admin/AdminTab'
import ContributionTab from './tabs/Contribution/ContributionTab'
import ConfigurationTab from './tabs/Configuration/ConfigurationTab'
import EducationTab from './tabs/Education/EducationTab'
import EnrollmentTab from './tabs/Enrollment/EnrollmentTab'
import HrisPayrollTab from './tabs/HrisPayroll/HrisPayrollTab'
import { OpenEnrollmentTab } from './tabs/OpenEnrollment/OpenEnrollmentTab'
import ProfileTab from './tabs/ProfileTab'

export default function ViewCustomer({ params }) {
  const { router } = useRouterContext()
  const { isLoading, data } = useViewCustomer({ id: params.id })
  const status = data?.status?.toLowerCase()
  const config = IconStatusMapper[status]
  const { params: searchParams, setParams } = useSearchParams<{
    tab?: string
  }>()
  const currentTab = searchParams.tab || 'company'
  const items: TabsProps['items'] = [
    {
      key: 'company',
      label: 'Company',
      children: <ProfileTab customer={data} contacts={data?.contacts ?? []} />,
    },
    {
      key: 'enrollment',
      label: 'Enrollment',
      children: <EnrollmentTab id={params.id} />,
    },
    {
      key: 'admin',
      label: 'Admin',
      children: <AdminTab id={params.id} />,
    },
    {
      key: 'hris/payroll',
      label: 'HRIS/Payroll',
      children: <HrisPayrollTab id={params.id} companyName={data?.name} />,
    },
    {
      key: 'contribution',
      label: 'Contribution',
      children: <ContributionTab id={params.id} />,
    },
    {
      key: 'education',
      label: 'Education',
      children: <EducationTab id={params.id} />,
    },
    {
      key: 'configuration',
      label: 'Configuration',
      children: <ConfigurationTab id={params.id} />,
    },
    {
      key: 'open-enrollment',
      label: 'Open Enrollment',
      children: <OpenEnrollmentTab id={params.id} />,
    },
  ]

  const handleTabChange = (key: string) =>
    setParams({ tab: key }, { replace: true })

  return isLoading ? (
    <Spin spinning fullscreen />
  ) : (
    <Page
      title={data?.name}
      breadcrumb={
        <BreadcrumbNav
          items={[
            { title: 'Customers', path: `/${CUSTOMER_MANAGEMENT}` },
            { title: data?.name },
          ]}
        />
      }
      headerContent={
        config ? (
          <Tag icon={config.icon} color={config.color}>
            <Typography size={16} style={{ textTransform: 'capitalize' }}>
              {status}
            </Typography>
          </Tag>
        ) : undefined
      }
      action={
        <Button
          type="primary"
          onClick={() => {
            router.push(`/${CUSTOMER_MANAGEMENT}/${params.id}/edit`)
          }}
        >
          Edit
        </Button>
      }
    >
      <Tabs
        type="card"
        activeKey={currentTab}
        items={items}
        destroyInactiveTabPane
        onChange={handleTabChange}
      />
    </Page>
  )
}
